module.exports = __webpack_public_path__ + "fonts/fa-regular-400.8bfca5e7.woff2";